'use client'

import dynamic from 'next/dynamic'
import { ENABLED_WALLET_NAMESPACES } from '../config'
import type { WalletNamespace } from '../types'

const WALLET_NAMESPACE_PROVIDERS: Partial<
  Record<WalletNamespace, React.ComponentType<{ children: React.ReactNode }>>
> = {
  evm: dynamic(() => import('../namespaces/evm/provider/evm-wallet-provider'), {
    ssr: false,
  }),
}

const providers = ENABLED_WALLET_NAMESPACES.map(
  (namespace) => WALLET_NAMESPACE_PROVIDERS[namespace],
).filter(Boolean) as React.ComponentType<{ children: React.ReactNode }>[]

export function WalletNamespacesProviders({
  children,
}: { children: React.ReactNode }) {
  return providers.reduceRight(
    (acc, Provider) => <Provider key={Provider.name}>{acc}</Provider>,
    children,
  )
}
